import { useQuery } from '@tanstack/react-query'
import useTranslation from '../../../modules/i18n/useTranslation'
import client from '../../../modules/sanityClient'
import { NEW_PRICING_PAGE_CMS_SECTION_QUERY } from '../../../sanity/groqQueries'
import { PRICING_PAGE_CMS_SECTION_QUERYResult } from '../../../sanity/types'
import { PlusDesktopSectionItem } from '../../landing/event/PlusDesktopSections'
import { PlusMobileSectionItem } from '../../landing/event/PlusMobileSections'

const fetchCMSData = async (slug) => {
  const post: PRICING_PAGE_CMS_SECTION_QUERYResult = await client.fetch(NEW_PRICING_PAGE_CMS_SECTION_QUERY, {
    slug,
  })
  return post
}

export const CMSDesktopSection = ({ slug, isPricingPage = false }) => {
  const { locale } = useTranslation()

  const { data: cmsData, isFetching: isFetchingCmsData } = useQuery({
    queryKey: ['desktop_cms_section', slug],
    queryFn: () => fetchCMSData(slug),
  })

  const arrayList = cmsData?.[locale]?.webSectionArray || []

  return (
    !isFetchingCmsData &&
    cmsData &&
    arrayList?.map((sectionItem, index) => (
      <PlusDesktopSectionItem item={sectionItem} key={sectionItem?._id} index={index} isPricingPage={isPricingPage} />
    ))
  )
}

export const CMSMobileSection = ({ slug }) => {
  const { locale } = useTranslation()
  const { data: cmsData, isFetching: isFetchingCmsData } = useQuery({
    queryKey: ['mobile_cms_section', slug],
    queryFn: () => fetchCMSData(slug),
  })

  const arrayList = cmsData?.[locale]?.mobileSectionArray || []

  return (
    !isFetchingCmsData &&
    cmsData &&
    arrayList?.map((sectionItem, index) => (
      <PlusMobileSectionItem item={sectionItem} key={sectionItem?._id} index={index} />
    ))
  )
}
